import api from './api';

class EmployeeService {
  // ======================================================
  // 🔹 LISTAR MEMBROS — AJUSTADO
  // ======================================================
  async listEmployees(empresaId: number) {
    const response = await api.get(`/empresa-membros/`, {
      params: { empresa_id: empresaId }
    });

    const data = response.data;

    if (!Array.isArray(data)) return [];

    return data.map((item: any) => ({
      id: item.id,
      nome: item.user?.nome_completo || "",
      email: item.user?.email || "",
      empresa: String(item.empresa),
      cargo: item.cargo || ""
    }));
  }

  // ======================================================
  // 🔹 CRIAR MEMBRO (POST)
  // admin deve enviar a própria senha: current_password
  // ======================================================
  async addEmployee(
    empresaId: number,
    data: {
      email: string;
      nome_completo: string;
      password: string;          // senha do funcionário
      cargo?: string;
      current_password: string;  // senha do admin
    }
  ) {
    const payload = {
      email: data.email,
      nome_completo: data.nome_completo,
      password: data.password,
      cargo: data.cargo,
      current_password: data.current_password // 🔥 essencial
    };

    const response = await api.post(`/empresa-membros/`, payload, {
      params: { empresa_id: empresaId }
    });

    return response.data;
  }

  // ======================================================
  // 🔹 EDITAR MEMBRO (PATCH)
  // sempre precisa current_password
  // ======================================================
  async updateEmployee(
    empresaId: number,
    id: number,
    data: {
      email?: string;
      nome_completo?: string;
      password?: string;         // nova senha do funcionário
      cargo?: string;
      current_password: string;  // senha do admin
    }
  ) {
    const payload: any = {
      current_password: data.current_password
    };

    if (data.email) payload.email = data.email;
    if (data.nome_completo) payload.nome_completo = data.nome_completo;
    if (data.cargo) payload.cargo = data.cargo;

    // Alteração de senha do funcionário
    if (data.password) {
      payload.password = data.password;
    }

    const response = await api.patch(`/empresa-membros/${id}/`, payload, {
      params: { empresa_id: empresaId }
    });

    return response.data;
  }

  // ======================================================
  // 🔹 DELETAR MEMBRO (DELETE)
  // precisa current_password do admin
  // ======================================================
  async deleteEmployee(
    empresaId: number,
    id: number,
    current_password: string
  ) {
    const response = await api.delete(`/empresa-membros/${id}/`, {
      params: { empresa_id: empresaId },
      data: { current_password }   // 🔥 backend exige body na deleção
    });

    return response.data;
  }
}

export const employeeService = new EmployeeService();
